export enum BankType {
  'plaid' = 'plaid',
  'wise' = 'wise',
}

export interface PlaidBankAccount {
  id: string;
  name: string;
  subtype: string;
  mask: string;
}

export interface BankAccount {
  id: string;
  bank: string;
  account: string;
  accountType: string;
  accountNumber: string;
  accountId: string;
  primaryAccount: boolean;
  tokenType: BankType;
  error: string;
  linkedContractAccountId?: string;
}
